
import React, { useEffect, useState } from 'react';
import './ImportValidationMessagePopup.css';

interface ImportValidationMessagePopupProps {
  errors: string[];
  onClose: () => void;
  title?: string;
  //errorParams: ErrorReportParams;
}

const ImportValidationMessagePopup: React.FC<ImportValidationMessagePopupProps> = (
    { 
        errors, 
        onClose, 
        title,
        //errorParams
      }) => {

  
  return (
    <div className="importValidationModal-overlay">
      <div className="importValidationModal-container">
        {/* Top Right Close Button */}
        <button className="close-button" onClick={onClose}>×</button>

        {/* Title */}
        <h2 className="importValidationModal-title">{title}</h2>

        {/* Scrollable Error List */}
        <div className="importValidationModal-content">
          {errors?.map((err, idx) => (
            <div key={idx} className={`error-row ${idx === errors.length - 1 ?
               'last-row' : ''}`} >
              {err}
            </div>
          ))}
        </div>
        
        <div className="note-text">
          <strong>Note:</strong> Please download the error report from the import page.
        </div>
        
        {/* Bottom Close Button */}
        <div className="importValidationModal-footer">
          <button onClick={onClose} className="close-footer-button">Close</button>
        </div>
      </div>
    </div>
  );
};

export default ImportValidationMessagePopup;
